export const eventTypes: Record<string, Record<string, string>> = {
  // posts
  '/api/v1/admin/posts/{postId}/block': {
    'POST': 'Блокировка поста',
    category: 'Посты'
  },
  '/api/v1/admin/posts/{postId}/unblock': {
    'POST': 'Разблокировка поста',
    category: 'Посты'
  },
  '/api/v1/admin/posts/{postId}/hide': {
    'POST': 'Теневой бан',
    category: 'Посты'
  },
  '/api/v1/admin/posts/{postId}/unhide': {
    'POST': 'Убрал из теневого бана',
    category: 'Посты'
  },

  // comments
  '/api/v1/admin/comment/{commentId}/block': {
    'GET': 'Блокировка комментария',
    category: 'Комментарии'
  },
  '/api/v1/admin/comment/{commentId}/unblock': {
    'GET': 'Разблокировка комментария',
    category: 'Комментарии'
  },

  // users
  '/api/v1/admin/complain/view/{id}': {
    'GET': 'Отмена жалобы на пользователя',
    category: 'Пользователи'
  },
  '/api/v1/admin/account/{userId}': {
    'PATCH': 'Обновление данных пользователя',
    'DELETE': 'Удаление пользователя',
    category: 'Пользователи'
  },
  '/api/v1/admin/block/{userId}': {
    'PATCH': 'Блокировка пользователя',
    category: 'Пользователи'
  },
  '/api/v1/admin/unblock/{userId}': {
    'PATCH': 'Разблокировка пользователя',
    category: 'Пользователи'
  },
  '/api/v1/admin/account': {
    'POST': 'Добавление пользователя',
    category: 'Пользователи'
  },

  // games
  '/api/v1/admin/game/add': {
    'POST': 'Добавление игры',
    category: 'Игры'
  },
  '/api/v1/admin/game/update': {
    'POST': 'Обновление игры',
    category: 'Игры'
  },
  '/api/v1/admin/game/delete/{gameId}': {
    'DELETE': 'Удаление игры',
    category: 'Игры'
  },

  // over
  'time': {
    'set': 'Время работы'
  }
};